import React, { useState } from "react";
import InputWithIcon from "./Input";
import styled from "styled-components";
import ButtonWithText from "./Button";
import { Heading5 } from "./Text";
import { colors } from "./colors";
import { post } from "app/popleads/networking/RequestService";
import { useExtensionContext } from "app/popleads/modules/extension/ExtensionContext";
import useAddAndRemoveTag from "app/popleads/hooks/useAddAndRemoveTag";
import { Spinner } from "react-bootstrap";
import EmptyStatus from "app/popleads/modules/extension/components/common/EmptyStatus";
import { toast } from "react-toastify";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

const StyledButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const StyledInputContainer = styled.div`
    margin-top: 8px;
    display: flex;
    gap: 8px;
    align-items: center;
`;

const StyledInputWrapper = styled.div`
    flex: 1;
`;

const StyledCardTitle = styled(Heading5)`
    color: ${colors.neutral[600]};
    display: block;
`;

const StyledTagContainer = styled.div`
    margin-top: 8px;
    margin-bottom: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const StyledTag = styled.div`
    display: flex;
    height: 32px;
    padding: 0 8px;
    border-radius: 8px;
    border: 1px solid ${colors.neutral[400]};
    background-color: ${colors.neutral[25]};
    color: ${colors.neutral[700]};
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    max-width: 163px;
`;
const StyledTagText = styled.span`
    margin-right: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
const StyledTagClose = styled.span`
    font-size: 16px;
    color: ${colors.neutral[500]};
    cursor: pointer;
    &:hover {
        color: ${colors.danger[700]};
    }
`;

const StyledTooltip = styled(Tooltip)`
    .tooltip-inner {
        font-size: 11px !important;
    }
`;

const TypeTag = () => {
    const { refetchProfile, profile, popit } = useExtensionContext();
    const [searchText, setSearchText] = useState("");
    const { insertTag, removeTag, loading } = useAddAndRemoveTag(post, refetchProfile, profile?.id);
    const [isInputOpen, setIsInputOpen] = useState(false);

    const handleOpenInput = () => {
        setIsInputOpen(!isInputOpen);
    };

    return (
        <Wrapper>
            <StyledButtonContainer>
                <StyledCardTitle>Tags</StyledCardTitle>
                <ButtonWithText
                    icon={isInputOpen ? "remove" : "add"}
                    onClick={() => {
                        if (popit) {
                            toast.warning("You need to POP the profile first.");
                        } else {
                            handleOpenInput();
                        }
                    }}
                    iconType="material"
                    variant="primary"
                    buttonStyle="default"
                    size="circle"
                />
            </StyledButtonContainer>
            {isInputOpen && (
                <form onSubmit={(e) => insertTag(e, searchText, setSearchText)} style={{ width: "100%" }}>
                    <StyledInputContainer>
                        <StyledInputWrapper>
                            <InputWithIcon
                                placeholder="Type tag"
                                type={"text"}
                                value={searchText}
                                minLength={1}
                                onChange={(e) => setSearchText(e.target.value)}
                                rightIcon={loading && <Spinner animation="border" variant="primary" size="sm" />}
                            />
                        </StyledInputWrapper>
                        <ButtonWithText
                            variant="primary"
                            buttonStyle="default"
                            size="midSmall"
                            type="submit"
                            onClick={(e) => insertTag(e, searchText, setSearchText)}
                            disabled={loading || !searchText.trim()}
                        >
                            Add
                        </ButtonWithText>
                    </StyledInputContainer>
                </form>
            )}
            {profile?.tag?.length > 0 ? (
                <StyledTagContainer>
                    {profile?.tag?.map((item) => (
                        <StyledTag key={item?.id}>
                            <OverlayTrigger
                                key={Math.random()}
                                placement={"top"}
                                overlay={
                                    <StyledTooltip id={`tooltip-top`} style={{ maxWidth: "100%" }}>
                                        {item?.tagName}
                                    </StyledTooltip>
                                }
                            >
                                <StyledTagText>{item?.tagName}</StyledTagText>
                            </OverlayTrigger>
                            <StyledTagClose
                                onClick={() => removeTag(item?.id, item?.tagName)}
                                className="material-icons"
                            >
                                close
                            </StyledTagClose>
                        </StyledTag>
                    ))}
                </StyledTagContainer>
            ) : (
                !isInputOpen && <EmptyStatus description="Click the + to put a tag." />
            )}
        </Wrapper>
    );
};

export default TypeTag;
